import React, { useEffect, useState } from 'react'
import NotEligibleFishingTruckView from './components/NotEligibleFishingTruckView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const NotEligibleFishingTruck = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('not-eligible', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <NotEligibleFishingTruckView setIsError={setIsError} />
}

export default withTranslation('common')(NotEligibleFishingTruck)
